<template>
	<div id="header" class="header-cont">
	  <div class="top-view">
		<div class="title" @click="logout()">
			<img class="logo" src="../assets/images/logo.png" alt=""></img>
			樂雅健康管理系统
		</div>
		<div class="nowTime">{{ currentTime }}</div>
	  </div>
	</div>
  </template>

  <style scoped lang="scss">
  #header {
	z-index: 99;
	padding: 32px 30px;
    position: fixed;
    top: 0;
    width: 100%;

	.top-view {
		display: flex;
		justify-content: space-between;

		.title {
			align-items: center;
			display: flex;
			font-weight: 500;
			font-size: 30px;
			color: #FFFFFF;
			line-height: 32px;
			color: #FFFFFF;

			.logo {
				width: 44px;
				height: 38px;
				margin-right: 9px;
			}
		}
		.nowTime {
			font-weight: 400;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 26px;
		}
	}
  }
  </style>

  <script>
import { logout } from "@api/index";


  export default {
	name: "Header",
	props: {},
	data: function() {
	  return {
      centerDialogVisible : false,
		  currentTime : '',
	  };
	},
	methods: {
		logout() {
			this.$dialog.confirm({
				mes: "确认退出登录?",
				opts: () => {
					logout().then(res => {
						this.$store.commit("LOGOUT");
						location.href = location.origin;
					})
					.catch(err => {
						console.log(err);
					});
				}
			});
		},
		updateCurrentTime() {
			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0');
			const day = String(now.getDate()).padStart(2, '0');
			const hours = String(now.getHours()).padStart(2, '0');
			const minutes = String(now.getMinutes()).padStart(2, '0');
			const seconds = String(now.getSeconds()).padStart(2, '0');
			this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
		}
	},
	mounted() {
		this.updateCurrentTime();
		setInterval(this.updateCurrentTime, 1000);
	}
  };
  </script>
